import { render, staticRenderFns } from "./paint-canvas.vue?vue&type=template&id=01a6e7c9"
import script from "./paint-canvas.vue?vue&type=script&lang=js"
export * from "./paint-canvas.vue?vue&type=script&lang=js"
import style0 from "./paint-canvas.vue?vue&type=style&index=0&id=01a6e7c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports